var _rect, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrafficSignal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 118,
    viewBox: "0 0 63 118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50.54,
    height: 105.735,
    x: 5.985,
    y: 5.985,
    stroke: "#FAC600",
    strokeWidth: 11.97,
    rx: 25.27
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.587,
    cy: 58.852,
    r: 10.973,
    fill: "#FAC600"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.587,
    cy: 84.123,
    r: 10.973,
    fill: "#BBD557"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.587,
    cy: 33.583,
    r: 10.973,
    fill: "#FF6F61"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 31.587,
    cy: 58.852,
    r: 24.938,
    fill: "#FAC600",
    opacity: 0.749,
    style: {
      mixBlendMode: "multiply"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrafficSignal);
export default __webpack_public_path__ + "static/media/traffic-signal.edeaf339e9dffde50f7483e84090403c.svg";
export { ForwardRef as ReactComponent };